// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'

export const SAVE_PREGUNTAS = 'SAVE_PREGUNTAS'

export const FETCH_AGREMIADO_SUCCESS = 'FETCH_AGREMIADO_SUCCESS'
export const UPDATE_AGREMIADO = 'UPDATE_AGREMIADO'

export const SAVE_SALDO = 'SAVE_SALDO'

export const SET_LIST = 'SET_LIST'
export const SET_FILTER = 'SET_FILTER'

export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_USER2 = 'UPDATE_USER2'
export const CREATE_USER = 'CREATE_USER'
export const DELETE_USER = 'DELETE_USER'

// pagos sat -> ruap
export const SET_DOCUMENT_TYPE = 'SET_DOCUMENT_TYPE'
export const SET_DOCUMENT_LAST_MOUNT = 'SET_DOCUMENT_LAST_MOUNT'
export const SET_STATUS_USER = 'SET_STATUS_USER'
export const SET_RUAP_RECEIVED = 'SET_RUAP_RECEIVED'
export const SET_DOCUMENT_REQUIREMENT = 'SET_DOCUMENT_REQUIREMENT'
export const SET_DOCUMENT_CHILD = 'SET_DOCUMENT_CHILD'
export const SET_DOCUMENT_INFO = 'SET_DOCUMENT_INFO'
export const SET_OTHER_RAP_NO_PAY = 'SET_OTHER_RAP_NO_PAY'
export const SET_RUAP_UPDATE_RECEIVED = 'SET_RUAP_UPDATE_RECEIVED'

// pagos administracion -> payservices
export const ADD_CPC_FORM = 'ADD_CPC_FORM'
export const SET_CONCEPTS = 'SET_CONCEPTS'
export const SET_CONCEPTS_FORM = 'SET_CONCEPTS_FORM'
export const SET_BANKS = 'SET_BANKS'
export const SET_ELECTRONIC_POINTS = 'SET_ELECTRONIC_POINTS'
export const SET_MODAL_FACTURA = 'SET_MODAL_FACTURA'
export const SET_QTY_CONCEPT = 'SET_QTY_CONCEPT'
export const ADD_USER_CONSULT = 'ADD_USER_CONSULT'
export const SET_CONCEPTSOLD_FORM = 'SET_CONCEPTSOLD_FORM'

// feedback.js
export const RESPONSE_MSG = 'RESPONSE_MSG'
export const CLEAR_MSG = 'CLEAR_MSG'



// WEBPACK FOOTER //
// ./resources/assets/js/store/mutation-types.js